import React, { useRef } from "react";
import { HiOutlineMailOpen } from 'react-icons/hi';
import { AiOutlineWhatsApp, AiOutlineMail, AiOutlineMessage } from 'react-icons/ai';
import emailjs from 'emailjs-com';

const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_3yfquqj', 'template_qom6y5o', form.current, 'WbUvbVi5asF3ROlw5')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });

        e.target.reset();
    };

    return (
        <section id="contact">
            <h5>Get In Touch</h5>
            <h2>Contact Me</h2>

            <div className="container contact_container">
                <div className="contact_options">
                    <article className="contact_option">
                        <AiOutlineMail className="contact_option-icon" />
                        <h5>Email</h5>
                        <h4>ashiqnoorsudheer@gmail.com</h4>
                        <a href="mailto:ashiqansalnoor@gmail.com" target="_blank" rel="noopener noreferrer">Send a message</a>
                    </article>

                    <article className="contact_option">
                        <AiOutlineWhatsApp className="contact_option-icon" />
                        <h5 className="con-opt-h">WhatsApp</h5>
                        <h4>+971522424612</h4>
                        <a href="https://api.whatsapp.com/send?phone=971522424612" target="_blank" rel="noopener noreferrer">Send a message</a>
                    </article>

                    <article className="contact_option">
                        <AiOutlineMessage className="contact_option-icon" />
                        <h5>Discord</h5>
                        <h4>Tenogri#2079</h4>
                        <a href="https://discordapp.com/channels/@me/Tenogri#2079/" target="_blank" rel="noopener noreferrer">Send a message</a>
                    </article>
                </div>

                <form ref={form} onSubmit={sendEmail} className="cont-form">
                    <input type="text" name='name' placeholder="Enter your name" required />
                    <input type="email" name='email' placeholder="Enter your email" required />
                    <textarea name="message" rows="7" placeholder="Enter your message" required></textarea>
                    <button type='submit' className='btn btn-primary'>Send Message</button>
                </form>
            </div>
        </section>
    );
}

export default Contact;
